export default __webpack_public_path__ + "img/d87fa59d5ed61990585e7555c22555f3.webp";